/* apps/viewer/src/app/home/settings-home/settings-home.component.scss */
.ori-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0);
}
.ori-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1);
}
.ori-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2);
}
.ori-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3);
}
.ori-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4);
}
.ori-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5);
}
.ori-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6);
}
.ori-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7);
}
.ori-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8);
}
.ori-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9);
}
.ori-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10);
}
.ori-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11);
}
.ori-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12);
}
.ori-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13);
}
.ori-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14);
}
.ori-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15);
}
.ori-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16);
}
.ori-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17);
}
.ori-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18);
}
.ori-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19);
}
.ori-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20);
}
.ori-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21);
}
.ori-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22);
}
.ori-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23);
}
.ori-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24);
}
:host {
}
:host .icon {
  align-items: center;
  background-color: #fafafa;
  cursor: pointer;
  display: flex;
  float: right;
  height: 100%;
  justify-content: center;
  max-width: 20%;
  transition: all ease 0.3s;
  width: 100%;
}
:host .icon ::ng-deep svg {
  height: 30px;
  transition: all ease 0.3s;
  width: 30px;
}
:host .icon:hover,
:host .icon:focus {
  transition: all ease 0.3s;
}
:host .icon:hover ::ng-deep svg,
:host .icon:focus ::ng-deep svg {
  fill: #fafafa;
  transition: all ease 0.3s;
}
:host mat-list {
  display: flex;
  flex-direction: column;
  height: calc(100% - 120px);
  justify-content: flex-start;
  padding: 0;
}
:host mat-list-item ::ng-deep .mat-icon {
  margin-right: 10px;
  vertical-align: bottom;
}
:host .item-clickable {
  cursor: pointer;
}
:host .item-clickable:focus {
  outline: none;
}
:host .item-clickable a {
  outline: none;
  text-decoration: none;
}
@media print {
  :host body {
    font-family: Sans-Serif;
  }
}
:host .login-container {
  color: #fafafa;
  display: grid;
  font-size: 13px;
  font-weight: 400;
  grid-template-columns: 50px 1fr 40px 40px;
  height: 60px;
}
:host .logo-user {
  display: grid;
  place-self: center;
}
:host .login-informations {
  align-self: center;
  display: grid;
  grid-template-columns: 1fr;
}
:host .login-name {
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host .cross-logo {
  align-self: center;
  min-width: 40px;
}
:host .offline-logo {
  margin: auto;
  width: 20px;
}
:host .logout {
  height: 40px;
  width: 40px;
}
:host .login-logo {
  background-color: #666;
  border: none;
  border-radius: 50%;
  color: white;
  display: inline-block;
  font-size: 18px;
  padding: 9px;
  text-align: center;
  text-decoration: none;
  width: 36px;
}
:host .mail {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host .icon-offline,
:host .icon-close {
  background-color: transparent;
  max-width: unset;
  width: 100%;
}
:host .user-auth {
  align-items: center;
  bottom: 0;
  color: #fafafa;
  display: grid;
  grid-template-columns: auto 1fr;
  height: 40px;
  margin-top: 20px;
  width: 100%;
}
:host .user-auth .mat-button {
  padding-right: 0;
}
:host .login-link {
  align-content: center;
  align-items: stretch;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin: auto;
}
:host .login-link .log-icon {
  margin: auto 5px;
  width: 25px;
}
:host .hide {
  cursor: default;
  visibility: hidden;
}
:host .mat-button {
  height: 100%;
}
:host .header {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}
:host .button-section {
  border-bottom: 1px solid #cecece;
}
/*# sourceMappingURL=settings-home.component.css.map */
